import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b409b7f0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-center" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "display-1 fw-bold text-danger" }, "404", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "h1 text-light" }, "ไม่พบหน้าที่เรียก", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "h2 fw-normal mt-3 mb-4 text-light" }, "เนื้อหาที่คุณเรียกอาจถูกนำออกไปแล้ว", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_BackgroundComponent = _resolveComponent("BackgroundComponent")!

  return (_openBlock(), _createBlock(_component_BackgroundComponent, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _hoisted_3,
        _hoisted_4,
        _createVNode(_component_RouterLink, {
          class: "btn btn-primary btn-lg",
          to: "/welcome"
        }, {
          default: _withCtx(() => [
            _createTextVNode("กลับสู่เว็บไซต์")
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}